import Toolbar from "material-ui/Toolbar";

export default Toolbar;



// WEBPACK FOOTER //
// ./src/components/uielements/toolbar/index.js